export interface Chapter {
  ep: number;
  title: string;
  date: string;
  synopsis: string;
}

export interface Drama {
  id: string;
  title: string;
  poster: string;
  banner: string;
  year: number;
  genre: string;
  region: string;
  episodes: number;
  updateTime: string;
  duration: string;
  director: string;
  writer: string;
  castIds: string[];
  tags: string[];
  rating: number;
  views: number;
  summary: string;
  fullSynopsis: string;
  chapters: Chapter[];
  featured: boolean;
  relatedIds: string[];
}

export const dramas: Drama[] = [
  {
    id: "fengliu-nvguandian",
    title: "风流女管家",
    poster:
      "https://readdy.ai/api/search-image?query=elegant%20retro%20Chinese%20television%20drama%20poster%2C%20graceful%20woman%20in%20a%20dark%20red%20qipao%20standing%20in%20a%20vintage%20mansion%20hallway%2C%20warm%20cinematic%20lighting%2C%20moody%20elegant%20atmosphere%2C%20rich%20burgundy%20and%20gold%20tones&width=600&height=900&seq=drama-fengliu-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20still%20of%20a%20vintage%20Chinese%20mansion%20interior%20with%20warm%20amber%20lamp%20light%2C%20dark%20red%20and%20gold%20color%20palette%2C%20elegant%20period%20drama%20atmosphere%2C%20soft%20long%20shadows%2C%20filmic%20composition&width=1600&height=900&seq=drama-fengliu-banner&orientation=landscape",
    year: 2023,
    genre: "年代情感 / 家族传奇",
    region: "内地",
    episodes: 40,
    updateTime: "2024-03-18",
    duration: "45分钟 / 集",
    director: "陈家明",
    writer: "苏婉宁",
    castIds: ["lin-wanqing", "lu-chenzhou", "su-jinyan", "qin-mu"],
    tags: ["年代", "家族", "女性成长", "商战", "虐恋"],
    rating: 8.7,
    views: 2864000,
    summary:
      "民国乱世，名门孤女苏曼姝以一介女管家之身撑起没落顾家，在权谋与情感的夹缝中步步为营。",
    fullSynopsis:
      "《风流女管家》以民国动荡年代为背景，讲述名门孤女苏曼姝在家族败落后，凭借过人的胆识与缜密的心思，以女管家身份重返顾家。她既要应对家族内部争产的明枪暗箭，又要在商场周旋中为顾家的产业寻得出路。\n\n表面风流洒脱的她，实则背负着为父母洗雪冤屈的秘密；而冷峻克制的顾家当家人顾廷之，则在一次次的试探与并肩中，逐渐看清她层层伪装下的真心。权谋、亲情、爱情与家国大义交织，苏曼姝一步步从任人轻视的“女管家”，成长为真正掌舵家族命运的人。",
    chapters: [
      { ep: 1, title: "重回顾宅", date: "2023-11-01", synopsis: "苏曼姝乔装应聘女管家，踏入阔别多年的顾家大门，尘封的往事随之浮现。" },
      { ep: 2, title: "一碗莲子羹", date: "2023-11-02", synopsis: "她用一碗旧日食谱的莲子羹，赢得老夫人的信任，也引起顾廷之的警觉。" },
      { ep: 3, title: "账本疑云", date: "2023-11-03", synopsis: "库房账目漏洞频出，曼姝顺藤摸瓜，却惊觉背后牵连着家族旧案。" },
      { ep: 4, title: "夜宴风波", date: "2023-11-04", synopsis: "顾家夜宴上各房暗中较劲，曼姝巧妙化解一场针对老夫人的刁难。" },
      { ep: 5, title: "旧照里的人", date: "2023-11-05", synopsis: "一张泛黄合影让曼姝确认了仇人的身份，情绪几乎失控。" },
      { ep: 6, title: "雨中试探", date: "2023-11-06", synopsis: "顾廷之在雨中截住曼姝，直言她并非寻常管家，两人第一次正面交锋。" },
      { ep: 7, title: "布庄之争", date: "2023-11-07", synopsis: "为夺回被侵占的布庄，曼姝提出以退为进的妙计，初显商业天赋。" },
      { ep: 8, title: "沈知微归来", date: "2023-11-08", synopsis: "留学归来的沈知微带着新式理念闯入顾家，三人关系暗流涌动。" },
      { ep: 9, title: "祖母的旧信", date: "2023-11-09", synopsis: "老夫人的一封旧信揭示了当年顾家与苏家的恩怨纠葛。" },
      { ep: 10, title: "交易与底线", date: "2023-11-10", synopsis: "对手开出诱人条件，曼姝在利益与原则之间艰难取舍。" },
      { ep: 11, title: "码头惊变", date: "2023-11-11", synopsis: "货船在码头突发变故，顾廷之与曼姝并肩应对，情愫暗生。" },
      { ep: 12, title: "谁是内鬼", date: "2023-11-12", synopsis: "家族机密接连外泄，曼姝设局引出潜伏在身边的暗桩。" },
      { ep: 13, title: "生日谜局", date: "2023-11-13", synopsis: "一场为老夫人操办的寿宴，成了各方势力交锋的战场。" },
      { ep: 14, title: "真相的重量", date: "2023-11-14", synopsis: "旧案真相浮出水面，曼姝却不得不面对它带来的连锁代价。" },
      { ep: 15, title: "离别与坚守", date: "2023-11-15", synopsis: "在去与留之间，曼姝最终选择守住顾家，也守住了心底的承诺。" },
      { ep: 16, title: "大结局·长风万里", date: "2023-11-16", synopsis: "恩怨尘埃落定，苏曼姝以女管家之身，书写了属于自己的传奇。" },
    ],
    featured: true,
    relatedIds: ["jinshang-wangshi", "yanhuo-nianhua", "chunfeng-xudu"],
  },
  {
    id: "jinshang-wangshi",
    title: "锦上往事",
    poster:
      "https://readdy.ai/api/search-image?query=retro%20Chinese%20drama%20poster%20of%20a%20young%20embroiderer%20in%20indigo%20silk%20robe%20in%20a%20sunlit%20workshop%2C%20faded%20warm%20tones%2C%20nostalgic%20storytelling%20mood%2C%20soft%20fabric%20textures&width=600&height=900&seq=drama-jinshang-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=sunlit%20vintage%20embroidery%20workshop%20interior%20with%20hanging%20silk%20and%20colorful%20threads%2C%20warm%20dusty%20afternoon%20light%2C%20nostalgic%20filmic%20atmosphere&width=1600&height=900&seq=drama-jinshang-banner&orientation=landscape",
    year: 2022,
    genre: "年代 / 女性励志",
    region: "内地",
    episodes: 36,
    updateTime: "2023-09-06",
    duration: "45分钟 / 集",
    director: "周慕白",
    writer: "林清和",
    castIds: ["su-jinyan", "han-zhaoyang", "shen-ruoxi"],
    tags: ["年代", "励志", "非遗", "成长"],
    rating: 8.3,
    views: 1920000,
    summary: "一名年轻的绣娘从深巷工坊走向大舞台，用一针一线绣出属于自己的锦绣人生。",
    fullSynopsis:
      "《锦上往事》讲述江南小镇绣娘阿锦凭借一手精湛的苏绣技艺，在时代变迁中不断突破偏见与困境，最终带着传统工艺走向更广阔舞台的故事。剧中细腻呈现了手艺人的坚守、匠心的传承，以及女性在变革年代的自我觉醒。",
    chapters: [
      { ep: 1, title: "深巷绣娘", date: "2022-08-01", synopsis: "阿锦在逼仄的巷子里接下第一单重活，命运的针脚就此落线。" },
      { ep: 2, title: "第一笔订单", date: "2022-08-02", synopsis: "一幅绣品意外走红，引来同行嫉妒与新的机遇。" },
      { ep: 3, title: "拜师之争", date: "2022-08-03", synopsis: "为求进益，阿锦登门求教却屡遭冷眼。" },
      { ep: 4, title: "绣架前的争执", date: "2022-08-04", synopsis: "新旧针法之争，让阿锦重新思考传统与创新的关系。" },
      { ep: 5, title: "远行的信", date: "2022-08-05", synopsis: "一封远方来信，为她打开了通往更大赛场的门。" },
      { ep: 6, title: "大结局·锦上添花", date: "2022-08-06", synopsis: "多年坚持终得回响，阿锦让苏绣之美被更多人看见。" },
    ],
    featured: false,
    relatedIds: ["fengliu-nvguandian", "chunfeng-xudu"],
  },
  {
    id: "yanhuo-nianhua",
    title: "烟火年华",
    poster:
      "https://readdy.ai/api/search-image?query=warm%20urban%20family%20drama%20poster%20of%20a%20mother%20and%20daughter%20in%20a%20small%20restaurant%20kitchen%2C%20steaming%20warmth%2C%20amber%20and%20red%20tones%2C%20tender%20everyday%20atmosphere&width=600&height=900&seq=drama-yanhuo-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=cozy%20old%20town%20street%20market%20at%20dusk%20with%20warm%20lantern%20light%20and%20rising%20steam%2C%20amber%20and%20red%20tones%2C%20tender%20slice%20of%20life%20filmic%20mood&width=1600&height=900&seq=drama-yanhuo-banner&orientation=landscape",
    year: 2024,
    genre: "都市 / 家庭生活",
    region: "内地",
    episodes: 32,
    updateTime: "2024-06-12",
    duration: "40分钟 / 集",
    director: "陈嘉言",
    writer: "何知远",
    castIds: ["xie-yunshu", "qin-mu", "shen-ruoxi"],
    tags: ["都市", "家庭", "治愈", "美食"],
    rating: 8.1,
    views: 1560000,
    summary: "老街小馆的两代人，用一日三餐的烟火，煨暖了彼此也煨暖了整条街坊。",
    fullSynopsis:
      "《烟火年华》以一家经营数十年的老街小馆为中心，讲述母女两代人在柴米油盐间化解误会、彼此支撑的故事。剧集以细腻的生活流叙事，展现平凡人面对现实压力时的坚韧与温柔，被观众称为“深夜治愈良药”。",
    chapters: [
      { ep: 1, title: "招牌汤面", date: "2024-05-01", synopsis: "小馆迎来拆迁通知，母亲坚持要把最后一碗汤面做好。" },
      { ep: 2, title: "回来的女儿", date: "2024-05-02", synopsis: "多年在外打拼的女儿归来，母女间旧账未清。" },
      { ep: 3, title: "街坊的账单", date: "2024-05-03", synopsis: "老顾客们用各自的方式，守护着这条街的味道。" },
      { ep: 4, title: "一场误会", date: "2024-05-04", synopsis: "一桩小事引爆积压多年的心结，母女深夜长谈。" },
      { ep: 5, title: "重开之约", date: "2024-05-05", synopsis: "女儿决定留下，与新老食客一同筹谋小馆的新生。" },
      { ep: 6, title: "大结局·人间烟火", date: "2024-05-06", synopsis: "小馆重新开张，烟火人间，人情未散。" },
    ],
    featured: false,
    relatedIds: ["fengliu-nvguandian", "chengshi-dengta"],
  },
  {
    id: "guyun-changan",
    title: "古韵长安",
    poster:
      "https://readdy.ai/api/search-image?query=period%20costume%20drama%20poster%20of%20a%20scholar%20in%20flowing%20dark%20robe%20holding%20a%20scroll%20at%20ancient%20city%20gate%2C%20dusk%20golden%20light%2C%20epic%20elegant%20tone&width=600&height=900&seq=drama-changan-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=epic%20ancient%20Chinese%20cityscape%20at%20dusk%20with%20towering%20gates%20and%20lanterns%2C%20golden%20hour%20light%2C%20misty%20mountain%20backdrop%2C%20cinematic%20scale&width=1600&height=900&seq=drama-changan-banner&orientation=landscape",
    year: 2023,
    genre: "古装 / 权谋",
    region: "内地",
    episodes: 46,
    updateTime: "2024-01-09",
    duration: "45分钟 / 集",
    director: "顾长风",
    writer: "白景行",
    castIds: ["lu-chenzhou", "han-zhaoyang", "gu-yanzhou"],
    tags: ["古装", "权谋", "群像", "史诗"],
    rating: 8.5,
    views: 2210000,
    summary: "一纸策论掀起长安风云，寒门书生与世家权臣在庙堂之上展开博弈。",
    fullSynopsis:
      "《古韵长安》以架空王朝的长安城为舞台，寒门学子沈砚之一纸策论入仕，卷入世家与皇权之间错综复杂的权力博弈。剧集以宏大的群像叙事和考究的礼制细节，勾勒出一幅波澜壮阔又暗藏危机的长安画卷。",
    chapters: [
      { ep: 1, title: "策论惊鸿", date: "2023-09-01", synopsis: "沈砚之的策论震动朝野，也为自己埋下祸根。" },
      { ep: 2, title: "入京赴考", date: "2023-09-02", synopsis: "初入长安，他见识了繁华之下的暗流。" },
      { ep: 3, title: "曲江夜宴", date: "2023-09-03", synopsis: "一场文人雅集，成了权贵互相试探的棋局。" },
      { ep: 4, title: "御前论策", date: "2023-09-04", synopsis: "沈砚之殿前直言，锋芒毕露引人忌惮。" },
      { ep: 5, title: "暗巷之约", date: "2023-09-05", synopsis: "他被迫与旧敌联手，只为扳倒更大的隐患。" },
      { ep: 6, title: "大结局·长安无夜", date: "2023-09-06", synopsis: "风波平定，长安城灯火依旧，人心却已不同。" },
    ],
    featured: false,
    relatedIds: ["fengliu-nvguandian", "xingchen-zhixia"],
  },
  {
    id: "chengshi-dengta",
    title: "城市灯塔",
    poster:
      "https://readdy.ai/api/search-image?query=modern%20city%20drama%20poster%20of%20a%20firefighter%20in%20dark%20uniform%20with%20warm%20street%20lights%20behind%2C%20night%20city%20bokeh%2C%20heroic%20tender%20tone&width=600&height=900&seq=drama-dengta-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=nighttime%20metropolitan%20skyline%20with%20glowing%20street%20lights%20and%20rain%20reflections%2C%20warm%20amber%20glow%20against%20cool%20blue%20city%20darkness%2C%20cinematic%20mood&width=1600&height=900&seq=drama-dengta-banner&orientation=landscape",
    year: 2024,
    genre: "都市 / 职业",
    region: "内地",
    episodes: 30,
    updateTime: "2024-08-20",
    duration: "45分钟 / 集",
    director: "郑立言",
    writer: "许安宁",
    castIds: ["qin-mu", "lin-wanqing", "xie-yunshu"],
    tags: ["都市", "职业", "救援", "热血"],
    rating: 8.2,
    views: 1780000,
    summary: "一群逆行者在城市的至暗时刻点亮灯塔，守护着千家万户的平安。",
    fullSynopsis:
      "《城市灯塔》聚焦一支城市应急救援队，通过一次次惊心动魄的救援任务，展现这群“逆行者”在危险与责任面前的抉择与坚守，也细腻描摹了他们脱下制服后的平凡生活与柔软情感。",
    chapters: [
      { ep: 1, title: "警报响起", date: "2024-07-01", synopsis: "新队员报到首日就遇上重大警情，考验骤然来临。" },
      { ep: 2, title: "第一次逆行", date: "2024-07-02", synopsis: "面对浓烟与火光，他第一次真正理解这身制服的分量。" },
      { ep: 3, title: "救援之外", date: "2024-07-03", synopsis: "任务之外的日常，藏着队员们各自的牵挂与难处。" },
      { ep: 4, title: "生死一线", date: "2024-07-04", synopsis: "一场突发事故让队伍面临组建以来最艰难的选择。" },
      { ep: 5, title: "并肩的人", date: "2024-07-05", synopsis: "队员之间的信任在并肩作战中愈加深厚。" },
      { ep: 6, title: "大结局·灯火可亲", date: "2024-07-06", synopsis: "城市华灯初上，他们依旧守在各自的岗位上。" },
    ],
    featured: false,
    relatedIds: ["yanhuo-nianhua", "xingchen-zhixia"],
  },
  {
    id: "chunfeng-xudu",
    title: "春风徐渡",
    poster:
      "https://readdy.ai/api/search-image?query=romantic%20period%20drama%20poster%20of%20a%20young%20couple%20under%20blossoming%20trees%20by%20a%20riverside%2C%20soft%20pink%20and%20warm%20cream%20tones%2C%20gentle%20lyrical%20mood&width=600&height=900&seq=drama-chunfeng-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=serene%20riverside%20jiangnan%20town%20at%20spring%20with%20blossoms%20and%20gentle%20mist%2C%20soft%20cream%20and%20pink%20tones%2C%20lyrical%20romantic%20filmic%20mood&width=1600&height=900&seq=drama-chunfeng-banner&orientation=landscape",
    year: 2022,
    genre: "年代 / 爱情",
    region: "内地",
    episodes: 34,
    updateTime: "2023-05-18",
    duration: "45分钟 / 集",
    director: "苏若初",
    writer: "苏婉宁",
    castIds: ["shen-ruoxi", "gu-yanzhou", "lin-wanqing"],
    tags: ["年代", "爱情", "治愈", "文艺"],
    rating: 8.0,
    views: 1340000,
    summary: "春风吹过渡口，两个被时代推着走的人，在漫长的等待里守护一段未竟的情意。",
    fullSynopsis:
      "《春风徐渡》以江南渡口小镇为背景，讲述邮差与女教师跨越数年的书信情缘。剧集以舒缓的节奏与细腻的情感，描绘普通人在时代洪流中的坚守、等待与重逢。",
    chapters: [
      { ep: 1, title: "渡口初见", date: "2022-04-01", synopsis: "一封送错的信，让两个陌生人有了第一次交集。" },
      { ep: 2, title: "每周的信", date: "2022-04-02", synopsis: "书信往来渐密，字里行间藏着说不出口的心意。" },
      { ep: 3, title: "雨季别离", date: "2022-04-03", synopsis: "一场变故让两人不得不面对分别。" },
      { ep: 4, title: "岁月的回信", date: "2022-04-04", synopsis: "多年后，尘封的信件被重新打开。" },
      { ep: 5, title: "风又起", date: "2022-04-05", synopsis: "重逢在即，他们却都成了不同的自己。" },
      { ep: 6, title: "大结局·春风渡口", date: "2022-04-06", synopsis: "春风再渡旧渡口，等待终于有了答案。" },
    ],
    featured: false,
    relatedIds: ["fengliu-nvguandian", "jinshang-wangshi"],
  },
  {
    id: "xingchen-zhixia",
    title: "星辰之下",
    poster:
      "https://readdy.ai/api/search-image?query=inspiring%20drama%20poster%20of%20a%20young%20astronomer%20looking%20up%20at%20a%20starry%20night%20sky%20from%20an%20observatory%2C%20deep%20indigo%20and%20warm%20amber%20accents%2C%20hopeful%20tone&width=600&height=900&seq=drama-xingchen-poster&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=starry%20night%20sky%20over%20a%20mountain%20observatory%20with%20glowing%20telescope%20dome%2C%20deep%20indigo%20and%20warm%20amber%20accents%2C%20awe%20inspiring%20filmic%20scale&width=1600&height=900&seq=drama-xingchen-banner&orientation=landscape",
    year: 2023,
    genre: "科幻 / 青春",
    region: "内地",
    episodes: 28,
    updateTime: "2024-02-14",
    duration: "40分钟 / 集",
    director: "凌未然",
    writer: "何以观",
    castIds: ["han-zhaoyang", "xie-yunshu", "gu-yanzhou"],
    tags: ["科幻", "青春", "成长", "理想"],
    rating: 8.4,
    views: 1620000,
    summary: "一群仰望星空的年轻人，把年少时的一个约定，变成了照亮彼此的理想。",
    fullSynopsis:
      "《星辰之下》讲述山区少年与天文社伙伴们，因一次流星雨许下的约定而结缘，此后各自奔赴又重聚于天文事业的故事。剧集以青春热血与科学浪漫交织的叙事，献给每一个不曾熄灭梦想的人。",
    chapters: [
      { ep: 1, title: "山那边的星空", date: "2023-12-01", synopsis: "一场流星雨，改变了少年对世界的想象。" },
      { ep: 2, title: "天文社", date: "2023-12-02", synopsis: "志同道合的伙伴在此相遇，理想悄然萌芽。" },
      { ep: 3, title: "第一次观测", date: "2023-12-03", synopsis: "简陋的设备与漫长的等待，只为一次清晰的瞬间。" },
      { ep: 4, title: "分歧与坚持", date: "2023-12-04", synopsis: "现实压力下，有人动摇，有人依然抬头仰望。" },
      { ep: 5, title: "重返山顶", date: "2023-12-05", synopsis: "多年之后，他们带着各自的成长回到起点。" },
      { ep: 6, title: "大结局·星辰之下", date: "2023-12-06", synopsis: "约定的那天，星空依旧，人也未曾走散。" },
    ],
    featured: false,
    relatedIds: ["guyun-changan", "chengshi-dengta"],
  },
];